import { Badge, type BadgeProps } from '@/shared/components/shadcn/badge';

type ScrapingStatusBadgeProps = {
  label: string;
  tone?: 'neutral' | 'progress' | 'success' | 'danger' | 'warning';
};

const toneVariant: Record<NonNullable<ScrapingStatusBadgeProps['tone']>, BadgeProps['variant']> = {
  neutral: 'outline',
  progress: 'secondary',
  success: 'default',
  danger: 'destructive',
  warning: 'secondary',
};

export function ScrapingStatusBadge({ label, tone = 'neutral' }: ScrapingStatusBadgeProps) {
  return <Badge variant={toneVariant[tone]}>{label}</Badge>;
}
